<template>
  <el-container
    id="container-post-editor"
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/post' }">文章列表</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">
        <!-- <post-form-content :form="form" style="margin-top: 80px;" /> -->
        <el-tabs v-model="activeLang" type="card">
          <el-tab-pane label="繁中" name="tw">
            <post-form-content :form="form" form-key="Tw"
              @title-changed="onTitleChanged"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">
            <post-form-content :form="form" form-key="Cn"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">
            <post-form-content :form="form" form-key="En"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">
            <post-form-content :form="form" form-key="Jp"/>
          </el-tab-pane>
        </el-tabs>

        <p class="auto-save-hint">{{autoSaveHint}}</p>
        <p class="url-hint">https://www.syunkaya.com.tw/blog/{{form.URLKey}}</p>

        <el-switch
          v-model="form.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>

        <el-tooltip v-if="!isEdit" class="item" effect="dark" placement="top-start">
          <div slot="content">文章網址路徑為以下: https://www.syunkaya.com.tw/blog/{{form.URLKey}}</div>
          <el-button type="primary" class="btn-set-url" size="mini" @click="showURLEditor">設定網址</el-button>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">一鍵翻譯會自動將繁體中文的內容翻譯成其他語言，<br>並且覆蓋資料!<br><br>包含圖片影片也會覆蓋，包含內容編輯器</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="autoTranslate">一鍵翻譯</el-button>
        </el-tooltip>

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>

      <u-r-l-setting-modal :isShow="isShowUrlSetModal" @close="isShowUrlSetModal = false" :url-key="form.URLKey" @submit="onSetURLKey"/>
    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import PostFormContent from '@/data/post/view/PostEditorForm.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import URLSettingModal from '@/data/post/view/URLSettingModal.vue'
import MixinOfTranslation from '@/utils/mixin-translate.vue'
import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required

export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinOfTranslation, MixinAutoSave],
  components: {
    LeftMenu,
    TopHeader,
    PostFormContent,
    URLSettingModal
  },
  data () {
    return {
      oriObj: {},
      form: {
        Tw: { Tags: [], IsActive: true, Date: moment().format(), Type: 'NewsArticle' },
        Cn: { Tags: [], IsActive: true, Date: moment().format(), Type: 'NewsArticle' },
        En: { Tags: [], IsActive: true, Date: moment().format(), Type: 'NewsArticle' },
        Jp: { Tags: [], IsActive: true, Date: moment().format(), Type: 'NewsArticle' }
      },
      activeLang: 'tw',
      isLoading: false,
      loadingHint: '',
      // url key
      isShowUrlSetModal: false,
      isURLKeySetManually: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createPost'
    },
    title () {
      return this.isEdit ? this.form.Tw.Title : '新增'
    }
  },
  methods: {
    /* url key 設置 */
    onTitleChanged () {
      if (this.isEdit) return
      if (!this.isURLKeySetManually) {
        this.form.URLKey = this.form.Tw.Title.replace(/\//g, '')
      }
    },
    onSetURLKey (urlKey) {
      this.isURLKeySetManually = true
      this.form.URLKey = urlKey
    },
    showURLEditor () {
      this.isShowUrlSetModal = true
    },
    /* end url key */
    submit () {
      if (!this.validateInput()) {
        return
      }
      if (this.isImageUploading()) {
        return alert('圖片上傳中，請稍後再送出')
      }

      for (let key of this.languages) {
        this.form[key].Tags = this.$store.state.postTag.list.filter(o => this.form[key].TagIDs.includes(o.ID))

        this.form[key].Contents = JSON.stringify(this.form[key].contentJsonArr)
        this.form[key].contentJsonArr = undefined
      }

      this.isLoading = true

      this.loadingHint = '正在上傳資料'

      let promise = this.isEdit
        ? this.$services.post.edit(this, this.form)
        : this.$services.post.add(this, this.form)
      promise
        .then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) this.onObjAddedit(res)
        })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    isImageUploading () {
      for (let lang of this.languages) {
        // 封面圖片
        if (this.form[lang]['coverImageBlob@3x'] && this.form[lang]['coverImageBlob@3x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@2x'] && this.form[lang]['coverImageBlob@2x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@1x'] && this.form[lang]['coverImageBlob@1x'] instanceof Blob) return true

        // 圖片編輯器
        for (let i in this.form[lang].contentJsonArr) {
          let obj = this.form[lang].contentJsonArr[i]
          if (!obj) continue
          if (obj.type === 'image' && obj.value.img instanceof Blob) {
            return true
          }
        }
      }
      return false
    },
    onObjAddedit (res) {
      this.clearCache()
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'post-list' })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.post.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.post.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.post.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown post for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Tw.Title) {
        errMsg = '請輸入名稱'
      }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    // tranlsate
    autoTranslate () {
      this.isLoading = true

      const translateKeys = ['Title']
      const syncKeys = ['CoverImageURLX3', 'CoverImageURLX2', 'CoverImageURLX1', 'CoverVideoUrl', 'CoverVideoDuration', 'CoverVideoPublishedAt', 'TagIDs', 'Date', 'Type']
      const contentJsonArr = this.form.Tw.contentJsonArr

      this.syncForm(syncKeys)
      // 每一次結束都先設定 isLoading=true，避免其中一個先完成而取消 loading
      let promises1 = this.translateForm(translateKeys).then(() => { this.isLoading = true })
      let promises2 = this.translateContentEditor(contentJsonArr).then(() => { this.isLoading = true })

      Promise.all([promises1, promises2]).then(() => {
        this.isLoading = false
      })
    }
  },
  created () {
    let id = parseInt(this.$route.params.id)
    if (id && id > 0) {
      let idx = this.$store.state.post.list.findIndex(o => o.ID === id)
      if (idx >= 0) {
        this.oriObj = this.$store.state.post.list[idx]
        this.form = JSON.parse(JSON.stringify(this.oriObj))

        for (let key of this.languages) {
          this.$set(this.form[key], 'TagIDs', this.form[key].Tags.map(o => o.ID))
        }
      } else {
        console.error(`unknown post for id ${id}`)
      }
    }

    // cache
    this.cacheKey = 'cache-post-' + (this.isEdit ? this.oriObj.ID : 0)
    let cache = this.getCache()
    if (cache) {
      this.confirmLoadCache().then(result => {
        if (result !== 'loaded') return
        let cacheForm = JSON.parse(cache)
        for (let key of this.languages) {
          cacheForm[key].TagIDs = cacheForm[key].Tags.map(o => o.ID)
        }
        this.form = cacheForm
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>

.btn-translate {
  position: absolute;
  top: 26px;
  right: 110px;
}

.btn-set-url {
  position: absolute;
  top: 26px;
  right: 205px;
}
.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 300px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
}

.url-hint {
  position: absolute;
  top: 0;
  left: 20px;
  color: gray;
  font-size: 14px;
}
</style>
